import { RouteFormatter } from '../routes';

export const BLOG_TYPES = {
    DOG_NAMES: { id: 'DOG_NAMES', name: 'Dog Names', slug: RouteFormatter.dogNames() },
    DOG_RESCUES: { id: 'DOG_RESCUES', name: 'Dog Rescues & Shelters', slug: RouteFormatter.dogRescue() },
    DOG_TRAINERS: { id: 'DOG_TRAINERS', name: 'Dog Trainers', slug: RouteFormatter.blogTrainersUS() },
};
